import {ParametroFactorConversionService} from './../../services/parametro-factor-conversion.service';
import {
  LfsaBotonEditarGridComponent
} from './../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UtilsService} from './../../../../shared/utils/utils.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {MaterialService} from '../../services/material.service';

@Component({
  selector: 'app-parametro-factor-conversion',
  templateUrl: './parametro-factor-conversion.component.html',
  styleUrls: ['./parametro-factor-conversion.component.css'],
})
export class ParametroFactorConversionComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.parametroFactorConversion;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public garita: any;
  public cmbMaterial: any[] = [];

  public agregarForm = new FormGroup({
    id: new FormControl(null, Validators.required),
    desca: new FormControl(null, [Validators.required, Validators.pattern(/[A-Za-z]+/)]),
    fact: new FormControl(null, Validators.required),
    mat: new FormControl(null, [Validators.required, Validators.pattern(/[A-Za-z0-9]+/)]),
    materialDescripcion: new FormControl('', Validators.required),
    uni: new FormControl(null, [Validators.required, Validators.maxLength(3)]),
    val: new FormControl(null, Validators.required),
  });

  constructor(
    private _util: UtilsService,
    private parametroFactorConversionS: ParametroFactorConversionService,
    private materialS: MaterialService
  ) {
  }

  get material() {
    return this.agregarForm.get('mat');
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        sortable: true,
        filter: true,
        width: 10,
      },
      {
        headerName: 'Descripción',
        field: 'desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Material',
        field: 'mat',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Factor Conversión',
        field: 'fact',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.girdComponent();
    this.obtenerParametroFactorConversion();
    this.agregarForm.get('id')?.disable({onlySelf: true});
  }

  searchMaterial() {
    this.materialS.obtenerPorId(
      this.material.value
    ).subscribe(
      resp => {
        if (resp) {
          this.agregarForm.get('materialDescripcion').setValue(resp.idMaterial + " - " + resp.dscaMaterial)
          return;
        }
        this.agregarForm.get('materialDescripcion').setValue('');
        this._util.mensajeErroToast('El material ingresado es incorrecto.');
      },
      error => {
        this.agregarForm.get('materialDescripcion').setValue('');
        this._util.mensajeErroToast('Ocurrió un error inesperado al buscar proveedor, inténtelo nuevamente.');
      }
    );
  }

  obtenerParametroFactorConversion() {
    this.loading = true;
    this.parametroFactorConversionS.obtener().subscribe(
      (resp) => {
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `Descripción: ${data.desca}`,
        action: this.DAT_BTNS.editar,
        funcion: this.parametroFactorConversionS.actualizar(
          data
        ),
      })
      .then(() => {
        this.obtenerParametroFactorConversion();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Descripción: ${data.desca}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.parametroFactorConversionS.crear(data),
      })
      .then(() => {
        this.obtenerParametroFactorConversion();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.openModal();
    this.agregarForm.reset();
    this.agregarForm.get('materialDescripcion').disable();
  }

  editar({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarForm.reset();
    this.agregarForm.get('materialDescripcion').disable();
    this.agregarForm.patchValue(rowData);
    this.searchMaterial();
    this.openModal();
  }

  eliminar({rowData}) {
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Descripción: ${rowData.desca}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.parametroFactorConversionS.borrar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerParametroFactorConversion();
      })
      .catch(() => {
        // loader
      });
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }
}
